export const CONFIGURE = 'GLOBAL/CONFIGURE';
export const SET_DEPLOY_GIT_SHA = 'GLOBAL/SET_DEPLOY_GIT_SHA';
export const SET_USER_DATA = 'GLOBAL/SET_USER_DATA';
export const SET_SUBSCRIPTION_EXPIRED = 'GLOBAL/SET_SUBSCRIPTION_EXPIRED';

export function init(payload) {
  return async dispatch => {
    dispatch({ type: CONFIGURE, payload });
  };
}

export function setDeployGitSHA(sha) {
  return async dispatch => {
    dispatch({ type: SET_DEPLOY_GIT_SHA, payload: sha });
  };
}

export function setUserData(payload) {
  return async dispatch => {
    dispatch({ type: SET_USER_DATA, payload });
  };
}

export function setSubscriptionExpired(payload) {
  return async dispatch => {
    dispatch({ type: SET_SUBSCRIPTION_EXPIRED, payload });
  };
}

export function setSubscriptionExpiredSync(payload) {
  return { type: SET_SUBSCRIPTION_EXPIRED, payload };
}
